// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__FudpZ","tabButtons":"Tab_tabButtons__qPnj-","active":"Tab_active__uRYAU","tabContent":"Tab_tabContent__lALwU"};